/**
 * StreamingIndicator — AI 타이핑 커서 인디케이터
 */

import { cn } from "@/shared/lib/utils";

export interface StreamingIndicatorProps {
  className?: string;
}

export function StreamingIndicator({ className }: StreamingIndicatorProps) {
  return (
    <span
      className={cn("inline-flex items-center gap-0.5 align-middle", className)}
      aria-label="AI가 응답 중입니다"
    >
      <span
        className="inline-block size-1.5 rounded-full bg-accent animate-bounce"
        style={{ animationDelay: "0ms" }}
      />
      <span
        className="inline-block size-1.5 rounded-full bg-accent animate-bounce"
        style={{ animationDelay: "150ms" }}
      />
      <span
        className="inline-block size-1.5 rounded-full bg-accent animate-bounce"
        style={{ animationDelay: "300ms" }}
      />
    </span>
  );
}
